import { ApiUrl } from "../../../assets/data/TkApiUrlProperty";
import http from "../../../services/http";
import {
  IAPI_CON005_Request,
  IAPI_CON005_Response,
  IAPI_CON012_Request,
  IAPI_CON012_Response,
} from "../../../type/apiType";

//「俸給の調整額」対象手当参照
const httpAPI_CON005 = async (
  param: IAPI_CON005_Request
): Promise<IAPI_CON005_Response> => {
  let res = await http.post(ApiUrl.API_CON005, {
    ...param,
  });

  return res.data;
};

//「俸給の調整額」対象手当更新
const httpAPI_CON012 = async (
  param: IAPI_CON012_Request
): Promise<IAPI_CON012_Response> => {
  let res = await http.post(ApiUrl.API_CON012, {
    ...param,
  });

  return res.data;
};

export { httpAPI_CON005, httpAPI_CON012 };
